module.exports = __webpack_public_path__ + "static/media/dog1.1646cf3e.jpg";